import { useSelector } from 'react-redux';
import { ResidentDetailsModel } from 'api/models';
import { selectUser } from 'store/redux/user/selectors';

export const useGetCurrentResidentFromLease = (
  residents: ResidentDetailsModel[],
) => {
  const user = useSelector(selectUser);

  return residents?.find(
    // Only used from the authenticated resident rent page, where `selectUser` is
    // populated. Asserting keeps the current throw for a missing user rather than
    // comparing against `undefined`, which would match any resident whose lease
    // carries no `userId`.
    (resident) => resident?.basicInfo?.userInfo?.userId === user!.userId,
  );
};
